export default function uniqueByKey( arr, key ) {
	return arr.filter(
		( obj, pos, arr2 ) => arr2.map( mapObj => mapObj[key] ).indexOf( obj[key] ) === pos
	);
}
